module.exports = __webpack_public_path__ + "static/media/omo.d34b27f6.jpg";